<script setup lang="ts">
import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import {useAlert} from "@/utils/alert";
import {ref} from "vue";
import {authService} from "@/features/auth/auth.service";
import {Eye, EyeOff} from "utruckin-icons";
import {useRouter} from "vue-router";
import {setToken} from "@/utils/token";
import {useTheme} from "@/utils/useMode";

const {show} = useAlert();
const router = useRouter();

const email = ref<string>("")
const password = ref<string>("")
const loading = ref<boolean>(false);
const typeInput = ref<"password" | "text">("password");
const {theme} = useTheme();

const login = async () => {
  loading.value = true;
  try {
    const {data} = await authService.login({
      email: email.value,
      password: password.value,
    })
    if (data.access_token) {
      show("Login successful", "success");
      setToken(data.access_token);
      router.push("/message");
    }
  } finally {
    loading.value = false
  }
};

const handleAppendClick = (e: Event) => {
  if (typeInput.value === "password") {
    typeInput.value = "text"

  } else {
    typeInput.value = "password"
  }
}
</script>

<template>
  <div class="v-login">
    <div class="main">
      <div class="logo">
        <img v-if="theme == 'light'" src="@/assets/images/logo.png" alt="company_logo"/>
        <img v-else src="@/assets/images/logo_dark.png" alt="company_logo"/>
      </div>
      <div class="body">
        <div class="body__header">
          Sign in
        </div>

        <div class="body__body">
          <CommonInput
              v-model:model-value="email"
              label="Email"
              placeholder="Email"
          />

          <CommonInput
              :type="typeInput"
              v-model:model-value="password"
              label="Password"
              placeholder="Password"
              :append-icon="typeInput == 'text' ? EyeOff : Eye"
              @append-icon-click="handleAppendClick"
          />
        </div>
        <div class="body__footer">
          <CommonButton @click="login" type="primary" label="Sign In"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.v-login {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-bg-tertiary);

  .main {
    width: 480px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: transparent;

    .logo {
      background: transparent;

      img {
        background: transparent;
      }
    }

    .body {
      width: 100%;
      background: var(--color-background);
      border-radius: 24px;
      border: 1px solid var(--color-border);
      box-shadow: 0 0 12px 0 #9D9B9B1A;
      padding: 24px;
      margin-top: 56px;

      &__header {
        display: flex;
        margin-bottom: 16px;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        color: var(--color-label);
      }

      &__body {
        border-top: 1px solid var(--color-border);
        border-bottom: 1px solid var(--color-border);
        padding: 24px 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      &__footer {
        display: flex;
        justify-content: end;
        padding-top: 24px
      }
    }

  }
}
</style>
